import Apis from '@/Apis/_'
import ResponseApi from '../interfaces/FactoryResponse'
import { HospitalConfiguracaoOperadora } from '../_'
import { CoreBase, ICoreBase } from './CoreBase'

class IntegracaoOperadora extends CoreBase implements IIntegracaoOperadora {
  async getHospitalConfiguracaoOperadora(hospitalId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getHospitalConfiguracaoOperadora(hospitalId)
    return response
  }

  async enviarHospitalConfiguracaoOperadora(hospitalId: string, configuracao: HospitalConfiguracaoOperadora): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.enviarHospitalConfiguracaoOperadora(hospitalId, configuracao)
    return response
  }

  async getConfiguracaoOperadoraById(hospitalId: string, convenioId: string): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.getConfiguracaoOperadoraById(hospitalId, convenioId)
    return response
  }

  async enviarOperadora(hospitalId: string, convenioId: string, params: any): Promise<ResponseApi> {
    const response = await Apis.Agendamento.AgendamentoMedicoBackofficeApi.enviarOperadora(hospitalId, convenioId, params)
    return response
  }
}

interface IIntegracaoOperadora extends ICoreBase {
  getHospitalConfiguracaoOperadora(hospitalId: string): Promise<ResponseApi>
  enviarHospitalConfiguracaoOperadora(hospitalId: string, configuracao: HospitalConfiguracaoOperadora): Promise<ResponseApi>
  getConfiguracaoOperadoraById(hospitalId: string, convenioId: string): Promise<ResponseApi>
  enviarOperadora(hospitalId: string, convenioId: string, params: any): Promise<ResponseApi>
}

export {
  IIntegracaoOperadora,
  IntegracaoOperadora,
}
